import * as R from 'ramda'
// @ts-ignore
import { createAction } from 'redux-actions'
import { dispatch, getState } from '$setup/redux'

export type OpenedRoomMessageToScroll =
  | null
  | 'bottom'
  | {
      iid: number
      highlight: boolean
      block: 'center' | 'end' | 'start'
      smooth?: 'smooth' | 'auto'
    }

interface OpenedRoomState {
  loading: boolean
  firstUnseenMessageIid: number
  messageToScroll?: OpenedRoomMessageToScroll
}

const initialState: OpenedRoomState = {
  loading: null,
  firstUnseenMessageIid: null,
  messageToScroll: null,
}

// reducer
const SET_OPENED_ROOM_DATA = 'SET_OPENED_ROOM_DATA'
const setOpenedRoomData = createAction(SET_OPENED_ROOM_DATA)
const dispatchSetOpenedRoomData = (data: Partial<OpenedRoomState>) =>
  dispatch(setOpenedRoomData(data))

// reducers
const reducers = {
  [SET_OPENED_ROOM_DATA]: R.mergeRight,
}

export const openedRoomStorage = {
  setLoading: (loading: boolean) => dispatchSetOpenedRoomData({ loading }),

  getLoading: () => getState().main.openedRoom.loading,

  setMessageToScroll: (messageToScroll: OpenedRoomState['messageToScroll']) =>
    dispatchSetOpenedRoomData({ messageToScroll }),

  setFirstUnseenMessageIid: (iid: number) =>
    dispatchSetOpenedRoomData({ firstUnseenMessageIid: iid }),
}

export const openedRoomReducer = (
  state = initialState,
  {
    type,
    payload,
  }: { type: keyof typeof reducers; payload: Partial<OpenedRoomState> },
) => (reducers[type] ? reducers[type](state, payload) : state)
